//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './AbpApplicationConfigurationClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type AbpApplicationConfigurationGetAbpApplicationConfigurationQueryParameters = {
  includeLocalizationResources?: boolean | undefined ;
}

export function abpApplicationConfigurationGetUrl(includeLocalizationResources?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/abp/application-configuration?";
if (includeLocalizationResources === null)
    throw new Error("The parameter 'includeLocalizationResources' cannot be null.");
else if (includeLocalizationResources !== undefined)
    url_ += "IncludeLocalizationResources=" + encodeURIComponent("" + includeLocalizationResources) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let abpApplicationConfigurationGetDefaultOptions: Omit<UseQueryOptions<Types.ApplicationConfigurationDto, unknown, Types.ApplicationConfigurationDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ApplicationConfigurationDto, unknown, Types.ApplicationConfigurationDto>, 'queryFn'>> = {
};
export function getAbpApplicationConfigurationGetDefaultOptions() {
  return abpApplicationConfigurationGetDefaultOptions;
};
export function setAbpApplicationConfigurationGetDefaultOptions(options: typeof abpApplicationConfigurationGetDefaultOptions) {
  abpApplicationConfigurationGetDefaultOptions = options;
}

export function abpApplicationConfigurationGetQueryKey(includeLocalizationResources?: boolean | undefined): QueryKey;
export function abpApplicationConfigurationGetQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { includeLocalizationResources,  } = params[0] as AbpApplicationConfigurationGetAbpApplicationConfigurationQueryParameters;

    return trimArrayEnd([
        'AbpApplicationConfigurationClient',
        'abpApplicationConfigurationGet',
        includeLocalizationResources as any,
      ]);
  } else {
    return trimArrayEnd([
        'AbpApplicationConfigurationClient',
        'abpApplicationConfigurationGet',
        ...params
      ]);
  }
}
export function __abpApplicationConfigurationGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.abpApplicationConfigurationGet(
      context.queryKey[2] as boolean | undefined,axiosConfig    );
}

export function useAbpApplicationConfigurationGetQuery<TSelectData = Types.ApplicationConfigurationDto, TError = unknown>(dto: AbpApplicationConfigurationGetAbpApplicationConfigurationQueryParameters, options?: Omit<UseQueryOptions<Types.ApplicationConfigurationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param includeLocalizationResources (optional) 
 * @return OK
 */
export function useAbpApplicationConfigurationGetQuery<TSelectData = Types.ApplicationConfigurationDto, TError = unknown>(includeLocalizationResources?: boolean | undefined, options?: Omit<UseQueryOptions<Types.ApplicationConfigurationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useAbpApplicationConfigurationGetQuery<TSelectData = Types.ApplicationConfigurationDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ApplicationConfigurationDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let includeLocalizationResources: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ includeLocalizationResources,  } = params[0] as AbpApplicationConfigurationGetAbpApplicationConfigurationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [includeLocalizationResources, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ApplicationConfigurationDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __abpApplicationConfigurationGet(context, axiosConfig) : __abpApplicationConfigurationGet,
    queryKey: abpApplicationConfigurationGetQueryKey(includeLocalizationResources),
    ...abpApplicationConfigurationGetDefaultOptions as unknown as Omit<UseQueryOptions<Types.ApplicationConfigurationDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param includeLocalizationResources (optional) 
 * @return OK
 */
export function setAbpApplicationConfigurationGetData(queryClient: QueryClient, updater: (data: Types.ApplicationConfigurationDto | undefined) => Types.ApplicationConfigurationDto, includeLocalizationResources?: boolean | undefined) {
  queryClient.setQueryData(abpApplicationConfigurationGetQueryKey(includeLocalizationResources),
    updater
  );
}

/**
 * @param includeLocalizationResources (optional) 
 * @return OK
 */
export function setAbpApplicationConfigurationGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ApplicationConfigurationDto | undefined) => Types.ApplicationConfigurationDto) {
  queryClient.setQueryData(queryKey, updater);
}